import React, { useEffect } from "react";
import { useImmer } from "use-immer";

import { ConfigurationDto } from "@intelligems/ig-types";
import { Grid } from "@mui/material";

import { useGetOrg } from "../../../../api/organizations/get-organization";
import Loading from "../../../../utils/Loading";

import { AdvancedConfigurations } from "./ConfigurationInputs/AdvancedConfigurations";
import { AdvancedActions } from "./AdvancedActions";

export const AdvancedSettings = () => {
  const organization = useGetOrg();

  const [settingsState, setSettingsState] = useImmer<ConfigurationDto[]>([]);

  useEffect(() => {
    setSettingsState(
      organization.data.org.configurations.filter(
        (config) => config.topic !== "WEB_UI_SCOPE"
      )
    );
  }, [organization.data.org.configurations]);

  if (settingsState && settingsState.length > 0) {
    return (
      <Grid container direction={"column"}>
        <Grid item mb={2}>
          <AdvancedActions />
        </Grid>
        <Grid item>
          <AdvancedConfigurations
            settingsState={settingsState}
            setSettingsState={setSettingsState}
          />
        </Grid>
      </Grid>
    );
  }
  return <Loading />;
};
